import Image from "next/image";

import type {
  BlockProps,
  StrapiBlock,
} from "@/app/components/blocks/types";

type Media = {
  id?: number;
  documentId?: string;
  url?: string | null;
  alternativeText?: string | null;
  width?: number | null;
  height?: number | null;
};

type AboutEquipeBlock = StrapiBlock & {
  __component: "blocks.about-equipe";
  titre?: string | null;
  description?: string | null;
  image?: Media | null;
};

export default function AboutEquipe({
  data,
}: BlockProps<AboutEquipeBlock>) {
  const { titre, description, image } = data;

  const imageUrl = image?.url || "";
  const imageAlt =
    image?.alternativeText ||
    titre ||
    "Présentation de l’équipe";

  return (
    <section className="bg-white py-14 lg:py-20">
      <div className="lms-container">
        <div className="mx-auto grid  items-center gap-12 lg:grid-cols-2 lg:gap-16">

          {/* CONTENU */}
          <div className="mx-auto">
            {titre && (
              <h2 className="text-4xl lg:text-[44px] font-roboto font-bold leading-tight text-primaryGreen ">
                {titre}
              </h2>
            )}

            <div className="my-5 h-1 w-10 rounded-full bg-primaryGreen" />

            {description && (
              <p className="whitespace-pre-line max-w-[750px] text-justify text-lg leading-relaxed text-textColor ">
                {description}
              </p>
            )}
          </div>

          {/* IMAGE */}
          <div className="relative mx-auto w-full lg:max-w-[620px]">
            {/* Cercle décoratif */}
            <div className="absolute -left-12 -top-12 h-40 w-40 rounded-full bg-greenPastel lg:h-48 lg:w-48" />

            <div className="relative aspect-[16/10] overflow-hidden rounded-[22px] bg-gray-100">
              {imageUrl && (
                <Image
                  src={imageUrl}
                  alt={imageAlt}
                  fill
                  className="object-cover"
                  sizes="(max-width: 1024px) 100vw, 620px"
                />
              )}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}